import { useMedia } from "react-use";

export default function useDeviceType() {
    const isMobile = useMedia("(max-width: 600px)");
    const isWebview = !!window.ReactNativeWebView;

    return { isMobile, isPC: !isMobile, isWebview };
}
